/* unplugin-vue-components disabled */import script from "./indexTop.vue?vue&type=script&setup=true&lang=js"
export * from "./indexTop.vue?vue&type=script&setup=true&lang=js"

import "./indexTop.vue?vue&type=style&index=0&id=7fb62cfe&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7fb62cfe"]])

export default __exports__